import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import {
  ChangesPoliciesAbsractComponent
} from '@app/modules/shared/policies-detail/abstracts/changes-policies.abstract';
import { TranslocoService } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { AirValidationCondition } from '@app/entities/air-validation.response';

@Component({
  selector: 'app-changes-policies',
  templateUrl: './changes-policies.component.html',
  styleUrls: ['../changes-policies.abstract.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChangesPoliciesComponent extends ChangesPoliciesAbsractComponent {

  constructor(public translateService: TranslocoService,
    public currencyFormat: CurrencyFormatPipe) {
    super(translateService, currencyFormat);
  }

  public buildLabelForChanges(): string {

    const hasChangesAllowed = () => this.flight?.ChangesAllowed || this.flight?.ChangesAllowedAfter;

    const hasSameFare = () => this.flight?.ChangesAmount?.Fare === this.flight?.ChangesAmountAfter?.Fare;

    const detailedLabelChangesBefore = !this.flight?.ChangesAllowed ?
      this.labelChangesNotAllowed : this.buildSingleLabelForChangesAllowed(this.flight, false);
    const detailedLabelChangesAfter = !this.flight?.ChangesAllowedAfter ?
      this.labelChangesNotAllowed : this.buildSingleLabelForChangesAllowed(this.flight, true);

    const labelBefore = () => `${this.labelForChangesBefore} ${detailedLabelChangesBefore}`;
    const labelAfter = () => `${this.laberForChangesAfter} ${detailedLabelChangesAfter}`;
    const labelForChanges = hasSameFare() ?
      this.buildSingleLabelForChangesAllowed(this.flight, false)
      : `${labelBefore()}. ${labelAfter()}`;

    return !hasChangesAllowed() ? this.labelChangesNotAllowed : labelForChanges;
  }

  private buildSingleLabelForChangesAllowed(flight: AirValidationCondition,
    isAfter: boolean): string {

    let fare: number = null;
    let currencyCode: string = null;

    if (isAfter) {
      fare = flight?.ChangesAmountAfter?.Fare;
      currencyCode = flight?.ChangesAmountAfter?.CurrencyCode;
      return this.hasChangesAmountPriceAfter(flight) ?
        this.buildLabelChangesWithFares(fare, currencyCode) : this.labelChangesWithoutFares;
    } else {
      fare = flight?.ChangesAmount?.Fare;
      currencyCode = flight?.ChangesAmount?.CurrencyCode;
      return this.hasChangesAmountPrice(flight) ?
        this.buildLabelChangesWithFares(fare, currencyCode) : this.labelChangesWithoutFares;
    }
  }

  get labelChangesWithoutFares(): string {
    const NO_COST = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_COST';
    return this.translateService.translate(NO_COST);
  }

  private buildLabelChangesWithFares(fare: number, currencyCode: string): string {
    const labelFareAmount = () => this.buildLabelFareAmount(fare, currencyCode);
    const FARE_DIFFERENCE = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.FARE_DIFFERENCE';
    const labelPlusFareDifference = this.translateService.translate(FARE_DIFFERENCE);
    return `${this.labelWithFares} (${labelFareAmount()} ${labelPlusFareDifference})`;
  }

  get labelChangesNotAllowed(): string {
    const CHANGES_NOT_ALLOWED = 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.CHANGES_NOT_ALLOWED';
    return this.translateService.translate(CHANGES_NOT_ALLOWED);
  }

  private hasChangesAmountPriceAfter(flight: AirValidationCondition): boolean {
    const { Fare, Taxes } = flight?.ChangesAmountAfter || {};
    return (flight?.ChangesAllowedAfter && (Fare > 0 || Taxes > 0));
  }

  private hasChangesAmountPrice(flight: AirValidationCondition): boolean {
    const { Fare, Taxes } = flight?.ChangesAmount || {};
    return (flight?.ChangesAllowed && (Fare > 0 || Taxes > 0));
  }

}
